/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-13 11:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { Field } from 'redux-form';
import { ExternalMinor } from '@shopify/polaris-icons';
// import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { RenderRadioPriceDisplay } from 'src/components/views/shopify-integration-settings/common/render-radio-price-display';
import { URL } from 'src/constants/links';

import {
  // PRODUCT_PRICE_DISPLAY_STYLE_OPTIONS,
  PRODUCT_COMPARE_AT_PRICE_POSITION_OPTIONS,
  ELEMENTS
} from 'src/constants/theme-settings';
// import { DropdownIndicator, styles } from './react-select-style';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductItemPriceForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, formValues } = this.props;

    // const formattedDisplayStyle = PRODUCT_PRICE_DISPLAY_STYLE_OPTIONS.map(item => {
    //   const label = item.format
    //     ? item.format
    //         .replace('label', i18n.translate(item.label))
    //         .replace('label2', i18n.translate(item.label2))
    //     : i18n.translate(item.label);
    //   return {
    //     ...item,
    //     label: label
    //   };
    // });

    const formattedCompareAtPricePosition = PRODUCT_COMPARE_AT_PRICE_POSITION_OPTIONS.map(item => {
      return {
        ...item,
        label: i18n.translate(item.label)
      };
    });

    const isEnableProductPrice = _.get(
      formValues,
      `setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.isEnable`,
      false
    );

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.productPrice_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['ProductPriceThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item">
            <Field
              name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.isEnable`}
              component={RenderToggleSwitch}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productPrice_Enable'
              )}
            />
          </div>

          {isEnableProductPrice && (
            <>
              {/* Show cents as superscript */}
              <div className="form-section__item form-section__item--standard-spacing">
                <Field
                  name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.showCentAsSuperscript`}
                  component={RenderCheckbox}
                  label={i18n.translate('AdminHTML.ThemeSetting.Form.productPrice_ShowSuperscript')}
                />
              </div>

              {/* Display style */}
              {/* <div className="form-section__item form-section__item--standard-spacing">
                <Field
                  name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.showMultiVariantPrice`}
                  component={RenderSelect2}
                  options={formattedDisplayStyle}
                  label={i18n.translate(
                    'AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Title'
                  )}
                  components={{ DropdownIndicator }}
                  styles={styles}
                  isSearchable={false}
                />

                <div style={{ marginTop: '12px' }}>
                  <TextStyle variation="subdued">
                    {i18n.translate('AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Note')}
                  </TextStyle>
                </div>
              </div> */}

              {/* Compare at price position */}
              <div className="form-section__item form-section__item--medium-spacing">
                <p className="title" style={{ marginBottom: '8px' }}>
                  {i18n.translate(
                    'AdminHTML.ShopifyIntegrationSettings.Form.productPrice_PriceDisplay'
                  )}
                </p>
                <div className="radio-button-wrapper radio-button-wrapper--large">
                  {formattedCompareAtPricePosition.map((item, index) => (
                    <Field
                      key={index}
                      name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.compareAtPricePosition`}
                      id={item.value}
                      component={RenderRadioPriceDisplay}
                      label={item.icon}
                    />
                  ))}
                </div>
              </div>

              {/* Show saving display */}
              <div className="form-section__item form-section__item--medium-spacing">
                <Field
                  name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE}.showSavingDisplay`}
                  component={RenderCheckbox}
                  label={i18n.translate(
                    'AdminHTML.ShopifyIntegrationSettings.Form.productPrice_ShowSavingText'
                  )}
                />
              </div>
            </>
          )}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductItemPriceForm);
